import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersFromSelected
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from dropdown having a value set
 * for the transfers group.
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersFromSelected(props) {
    // Initalize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // then update the from property of the transfer passing the account to be selected.
    // Call the submit function to make the change
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .submit();

    // Return the TransfersePage passing the data variable
    return <TransfersPage data={ data } />
}